// Updated personal-sources.ts
import psos1 from "@/assets/audios/Personal-sources-of-strength-Bullet-point-1.m4a";
import psos2 from "@/assets/audios/Personal-sources-of-strength-bullet-point-2.m4a";
import psos3 from "@/assets/audios/Personal-sources-of-strength-bullet-point-3.m4a";
import psos4 from "@/assets/audios/Personal-sources-of-strength-Bullet-point-4.m4a";
import psos5 from "@/assets/audios/Personal-sources-of-strength-bullet-point-5.m4a";
import psos6 from "@/assets/audios/Personal-sources-of-strength-bullet-point-6.m4a";
import psos7 from "@/assets/audios/Personal-sources-of-strength-bullet-point-7.m4a";
import psos8 from "@/assets/audios/Personal-sources-of-strength-bullet-point-8.m4a";
import psos9 from "@/assets/audios/Personal-sources-of-strength-Bullet-point-9.m4a";
import psos10 from "@/assets/audios/Personal-sources-of-strength-bullet-point-10.m4a";
import psos11 from "@/assets/audios/Personal-sources-of-strength-Bullet-point-11.m4a";
import { getPersonalSourcesRoutes, type Audience } from "@/lib/helpers/personalSourcesRoutes";

export interface PersonalSourcesData {
  id: string;
  titleKey: string; // Changed to translation key
  contentKey: string; // Changed to translation key
  audio: string;
}

const getPersonalSourcesData = (audience: Audience): Array<PersonalSourcesData & { nextRoute: string }> => {
  const routes = getPersonalSourcesRoutes(audience);
  
  return [
    {
      id: "1",
      titleKey: "personalSources.step1.title",
      contentKey: "personalSources.step1.content",
      audio: psos1,
      nextRoute: routes.step("2"),
    },
    {
      id: "2",
      titleKey: "personalSources.step2.title",
      contentKey: "personalSources.step2.content",
      audio: psos2,
      nextRoute: routes.step("3"),
    },
    {
      id: "3",
      titleKey: "personalSources.step3.title",
      contentKey: "personalSources.step3.content",
      audio: psos3,
      nextRoute: routes.step("4"),
    },
    {
      id: "4",
      titleKey: "personalSources.step4.title",
      contentKey: "personalSources.step4.content",
      audio: psos4,
      nextRoute: routes.step("5"),
    },
    {
      id: "5",
      titleKey: "personalSources.step5.title",
      contentKey: "personalSources.step5.content",
      audio: psos5,
      nextRoute: routes.step("6"),
    },
    {
      id: "6",
      titleKey: "personalSources.step6.title",
      contentKey: "personalSources.step6.content",
      audio: psos6,
      nextRoute: routes.step("7"),
    },
    {
      id: "7",
      titleKey: "personalSources.step7.title",
      contentKey: "personalSources.step7.content",
      audio: psos7,
      nextRoute: routes.step("8"),
    },
    {
      id: "8",
      titleKey: "personalSources.step8.title",
      contentKey: "personalSources.step8.content",
      audio: psos8,
      nextRoute: routes.step("9"),
    },
    {
      id: "9",
      titleKey: "personalSources.step9.title",
      contentKey: "personalSources.step9.content",
      audio: psos9,
      nextRoute: routes.step("10"),
    },
    {
      id: "10",
      titleKey: "personalSources.step10.title",
      contentKey: "personalSources.step10.content",
      audio: psos10,
      nextRoute: routes.step("11"),
    },
    {
      id: "11",
      titleKey: "personalSources.step11.title",
      contentKey: "personalSources.step11.content",
      audio: psos11,
      nextRoute: routes.summary(""),
    },
  ];
};

export async function getPersonalSourcesStep(id: string, audience: Audience = "adults") {
  return getPersonalSourcesData(audience).find((step) => step.id === id);
}

export async function getPersonalSourcesTitle(id: string, audience: Audience = "adults") {
  const step = await getPersonalSourcesStep(id, audience);
  return step?.titleKey || "personalSources.title";
}

// Helper function to get the main title key
export function getPersonalSourcesMainTitleKey() {
  return "personalSources.title";
}
